import React, { Component } from 'react'

import TextPage from '../block/TextPage'
import Oblast from '../block/Oblast'
import Faq from '../block/Faq'

class App extends Component {

  render() {

    const data = this.props?.data

    return (
      <>
        <TextPage data={data} />
        <Oblast data={data} />
        <Faq data={data} />
      </>
    )
  }
}

export default App